import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { AppConfig } from '../config';

export function useRestaurantDetail(config: AppConfig, permitNumber: string | null) {
  return useQuery({
    queryKey: ['restaurant', permitNumber],
    queryFn: () => api.detail(config, permitNumber as string),
    enabled: permitNumber !== null,
    staleTime: 60_000,
  });
}
